import { Link, useLocation } from "react-router-dom";
import { Logo, BRAND } from "@/components/Brand";
import { ChevronLeft } from "lucide-react";

const NAV = [
  { to: "/aviso-legal", label: "Aviso legal" },
  { to: "/privacidad", label: "Privacidad" },
  { to: "/cookies", label: "Cookies" },
  { to: "/terminos", label: "Términos de uso" },
  { to: "/contratacion", label: "Condiciones de contratación" },
  { to: "/eliminar-cuenta", label: "Eliminar mi cuenta" },
];

export default function LegalLayout({ title, updatedAt, children }) {
  const loc = useLocation();
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200" data-testid="legal-page">
      <header className="sticky top-0 z-30 bg-slate-950/80 backdrop-blur border-b border-white/10">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Logo size={32} />
            <span className="font-display font-bold text-white">{BRAND.name}</span>
          </Link>
          <Link to="/" className="text-sm text-slate-300 hover:text-white inline-flex items-center gap-1">
            <ChevronLeft className="w-4 h-4" /> Volver
          </Link>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-4 py-10 grid md:grid-cols-[220px_1fr] gap-8">
        <aside className="md:sticky md:top-20 self-start">
          <nav className="flex md:flex-col gap-1 overflow-x-auto md:overflow-visible pb-2 md:pb-0">
            {NAV.map((it) => {
              const active = loc.pathname === it.to;
              return (
                <Link
                  key={it.to}
                  to={it.to}
                  data-testid={`legal-nav-${it.to.replace(/\//g, "")}`}
                  className={`whitespace-nowrap md:whitespace-normal text-sm px-3 py-2 rounded-lg transition-colors ${
                    active ? "bg-blue-600 text-white" : "text-slate-300 hover:bg-white/5"
                  }`}
                >
                  {it.label}
                </Link>
              );
            })}
          </nav>
        </aside>

        <main className="min-w-0 prose prose-invert max-w-none">
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-white mb-2">{title}</h1>
          <p className="text-sm text-slate-400 mb-8">Última actualización: {updatedAt || BRAND.legal.lastUpdate}</p>
          <div className="space-y-6 text-[15px] leading-relaxed [&_h2]:text-white [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-bold [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:text-white [&_h3]:font-semibold [&_h3]:mt-6 [&_h3]:mb-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-1 [&_a]:text-blue-400 [&_a]:underline [&_strong]:text-white">
            {children}
          </div>
        </main>
      </div>

      <footer className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} {BRAND.name} · {BRAND.legal.holder} · {BRAND.legal.nif}
      </footer>
    </div>
  );
}
